export enum ESaveSortDirection {
  SSD_Ascending,
  SSD_Descending,
}

export const ESaveSortDirectionDisplayName = {
  [ESaveSortDirection.SSD_Ascending]: 'Ascending',
  [ESaveSortDirection.SSD_Descending]: 'Descending',
};
